import { Outlet } from "react-router";
import { Toaster } from "sonner";

function CommonLayout() {
  return (
    <>
      <Toaster richColors position="bottom-center" />
      <Outlet />
    </>
  );
}

export const route = {
  element: <CommonLayout />,
};
